export function poCode({ _id, createdAt, type }: any, { rmType, isInternational }: any ): string {
  let poCode = isInternational ? 'F' : 'L';
  if(type === 'Spare Parts') {
    poCode = poCode + 'SP';
  } else {
    const poType = rmType === 'ORM' ? 'OM' : 'RM';
    poCode = poCode + poType;
  }
  const poDate = createdAt ? new Date(createdAt) : new Date();
  const year = poDate.getFullYear();
  if(_id) {
    poCode =  poCode + `/${_id}`;
  }
  poCode =  poCode + `/${year}`;
  return poCode;
}